








































































































































































import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { TbGoods, TbGoodsClass, TbGrade, TbMember, TbReport } from '@/http';
import { calendarPanel,NumberKeyboard } from "@/components";
import calculate from '@/common/util/calculate';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')
import { fmoney } from '@/common/money';
@Component({ 
    components: {
        calendarPanel,NumberKeyboard
    },
})
export default class saleOrder extends Vue {
    public $refs: {
        barcode:HTMLFormElement;
    };

    @Prop({
        type:Object,
        default:()=>{

        }
    })
    form:any;

    gradeList = [];

    /**查询项 */
    searchValue={
        orderNo:"",
        paymentMethod:null,
        startTime:"",
        endTime:"",
        skip:0,
        count:10,
    }
    /**时间类型下拉 */
    showStatusPopover = false;
    typeOptions=[
        {
            label:"全部支付方式",
            value:null,
        },
        {
            label:"会员卡",
            value:1,
        },
        {
            label:"现金",
            value:2,
        },
        {
            label:"微信",
            value:3,
        },
        {
            label:"支付宝",
            value:4,
        },
        {
            label:"现金/会员卡/微信",
            value:5,
        },
        {
            label:"现金/会员卡/支付宝",
            value:6,
        },
        {
            label:"现金/微信",
            value:7,
        },
        {
            label:"现金/支付宝",
            value:8,
        },
        {
            label:"会员卡/微信",
            value:9,
        },
        {
            label:"会员卡/支付宝",
            value:10,
        },
        {
            label:"现金/会员卡",
            value:11,
        },
        {
            label:"线下微信",
            value:13,
        },
        {
            label:"线下支付宝",
            value:14,
        },
        {
            label:"现金/线下支付宝",
            value:15,
        },
        {
            label:"会员卡/线下支付宝",
            value:16,
        },
        {
            label:"现金/线下微信",
            value:17,
        },
        {
            label:"会员卡/线下微信",
            value:18,
        },
        {
            label:"线下微信/线下支付宝",
            value:19,
        },
        {
            label:"现金/会员卡/线下支付宝",
            value:20,
        },
        {
            label:"现金/会员卡/线下微信",
            value:21,
        },
        {
            label:"现金/线下支付宝/线下微信",
            value:22,
        },
        {
            label:"会员卡/线下支付宝/线下微信",
            value:23,
        },
        {
            label: "会员卡/线下支付宝/线下微信/现金",
            value: 24,
        },
        
    ]

    /**时间控件 */
    pickerShow = false;
    startDate="";
    endDate="";

    /**列表展示
     * 1:图
     * 2：表格
     */
    showType=1;

    userInfo:any={};

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    currentPage=1
    totalStock=0;

    timeActive=null;

    /**新增会员弹窗 */
    addVipShow = false;
    isAdd = true;

    totalInfo:any={};

    fmoney = fmoney;

   get getTypeStatus(){
    let str = "";
    str = this.typeOptions.find(v=>v.value==this.searchValue.paymentMethod).label
    return str;
   }

   @Watch('searchValue.orderNo')
   orderNoChange(){
    this.onRefresh();
   }

    created() {
       
    }

    async mounted(){
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));

        this.getInputFocus()
        document.addEventListener('click',this.chargeInputFocus)
        
    }

    async scanInput(val){
        this.searchValue.orderNo = val;
    }
    getInputFocus(){
        this.$nextTick(()=>{
            this.$refs['barcode'].select()
            document.addEventListener('keydown', this.handleScanCode)
        })
    }
    chargeInputFocus(event){
        if (event.target.tagName.toLowerCase() != 'input') {
            this.getInputFocus()
        }
    }
    beforeDestroy() {
        document.removeEventListener('keydown',this.handleScanCode) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
        document.removeEventListener('click', this.chargeInputFocus)
    }
    public scanCodes:any = ''
   /**
     * 监听扫码枪输入
     */
    async handleScanCode(event) {
        if (event.key === 'Backspace' || event.keyCode === 8) {
        // 允许退格键的默认行为
        return;
    }
        if (event.key === 'Enter' || event.keyCode == 13) {
            this.scanInput(event.target.value)
            this.scanCodes = ''
        return
        }
    }

    getPayName(val){
        let str = "";
        switch (val) {
            case 1:
                str="会员卡"
                break;
            case 2:
                str="现金"
                break;
            case 3:
                str="微信"
                break;
            case 4:
                str="支付宝"
                break;
            case 5:
                str="现金+会员卡+微信"
                break;
            case 6:
                str="现金+会员卡+支付宝"
                break;
            case 7:
                str="现金+微信"
                break;
            case 8:
                str="现金+支付宝"
                break;
            case 9:
                str="会员卡+微信"
                break;
            case 10:
                str="会员卡+支付宝"
                break;
            case 11:
                str="现金+会员卡"
                break;
                case 13:
                    str="线下微信"
                    break;
                case 14:
                    str="线下支付宝"
                    break;
                case 15:
                    str="现金+线下支付宝"
                    break;
                case 16:
                    str="会员卡+线下支付宝"
                    break;
                case 17:
                    str="现金+线下微信"
                    break;
                case 18:
                    str="会员卡+线下微信"
                    break;
                case 19:
                    str="线下微信+线下支付宝"
                    break;
                case 20:
                    str="现金+会员卡+线下支付宝"
                    break;
                case 21:
                    str="现金+会员卡+线下微信"
                    break;
                case 22:
                    str="现金+线下支付宝+线下微信"
                    break;
                case 23:
                    str="会员卡+线下支付宝+线下微信"
                    break;
                case 24:
                    str="会员卡+线下支付宝+线下微信+现金"
                    break;
            default:
                break;
        }
        return str;
    }    
   
    openselDate() {
        this.pickerShow = true;
    }
    /**确定选择时间 */
    onselConfirm(date){
        const [start, end] = date;
        this.startDate = dayjs(start).format("YYYY-MM-DD");
        this.endDate = dayjs(end).format("YYYY-MM-DD");
    
        this.pickerShow = false;
        this.timeActive = null;
        this.setTimeSearch();
    }
    closeTime(){
        this.pickerShow = false;
    }
    
    /**下拉刷新 */
    onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.searchValue.skip=0;
      this.searchValue.count = 10;
      this.currentPage = 1;
      this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }
            

            let s = this.searchValue.count;
            let res = await TbReport.GetTbSaleReportList(Object.assign({},this.searchValue,{
                memberPhone:this.form.phone,
                orderType:1,
            }))
            this.list = this.searchValue.skip==0? res.items.map(v=>{
                return{
                    ...v,
                    createTime:dayjs(v.createTime).format('YYYY-MM-DD'),
                    orderDiscount:v.orderDiscount? calculate.multiplication(v.orderDiscount,100)+'%':'/'
                }
            }):this.list.concat(res.items.map(v=>{
                return{
                    ...v,
                    createTime:dayjs(v.createTime).format('YYYY-MM-DD'),
                    orderDiscount:v.orderDiscount? calculate.multiplication(v.orderDiscount,100)+'%':'/'
                }
            }));
            this.total  = res.totalCount;
            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            await this.getTotal();
            if (this.list.length >= this.total) {
            this.finished = true;
            
            }
    }
    async getTotal(){
        let res = await TbReport.GetTbSaleReportTotal(Object.assign({},this.searchValue,{
            memberPhone:this.form.phone,
            orderType:1,
        }))
        this.totalInfo = res;
    }
    /**获取商品列表 */
    async getList(){
        // this.onRefresh();
        this.list = [];
        this.searchValue.skip=0;
        this.searchValue.count=10;
        this.total = 0;
        this.currentPage = 1;

        let res = await TbReport.GetTbSaleReportList(Object.assign({},this.searchValue,{
            memberPhone:this.form.phone,
            orderType:1,
        }))
        this.list = res.items.map(v=>{
            return{
                ...v,
                createTime:dayjs(v.createTime).format('YYYY-MM-DD'),
                orderDiscount:v.orderDiscount? calculate.multiplication(v.orderDiscount,100)+'%':'/'
            }
        });
        this.total  = res.totalCount;
        await this.getTotal();
    }
    /**重置 */
    resetSearch(){
        this.searchValue={
            orderNo:"",
            paymentMethod:null,
            startTime:"",
            endTime:"",
            skip:0,
            count:10,
        }
        this.timeActive=null;
        this.startDate = "";
        this.endDate = "";
        this.showStatusPopover = false;
        this.onRefresh();
    }
   
    sortFun(val){}
    changeTypeStatusXL(item,index){
        this.showStatusPopover = false;
        this.searchValue.paymentMethod = item.value;
        this.onRefresh();
    }
    async chooseTime(type){
        this.timeActive = type;
        // 获取当前日期
        const today = dayjs();
        const firstDayOfWeek = dayjs().startOf('week');
        const firstDayOfMonth = dayjs().startOf('month');
        const prevMonthStart = today.subtract(1, 'month').startOf('month');  
        const prevMonthEnd = today.subtract(1, 'month').endOf('month')
        switch (type) {
            case 1:
                this.startDate = today.format("YYYY-MM-DD");
                this.endDate = today.format("YYYY-MM-DD");
                break;
            case 2:
                this.startDate = firstDayOfWeek.format("YYYY-MM-DD");
                this.endDate = today.format("YYYY-MM-DD");
                break;
            case 3:
                this.startDate = firstDayOfMonth.format("YYYY-MM-DD");
                this.endDate = today.format("YYYY-MM-DD");
                break;
            case 4:
                this.startDate = prevMonthStart.format("YYYY-MM-DD");
                this.endDate = prevMonthEnd.format("YYYY-MM-DD");
                break;
        
            default:
                break;
        }
        await this.setTimeSearch();
    }
    async setTimeSearch(){
        this.searchValue.startTime = this.startDate+" 00:00:00";
        this.searchValue.endTime = this.endDate+" 23:59:59";
        await this.onRefresh();
    }

    
    
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/vip/components/saleOrder.vue